import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import { Table, Button } from 'react-bootstrap'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { VestigingEnum } from 'shared/models/Enum'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { IModalReference } from 'shared/models/References'
import RouteToAddressSearch from './RouteToAddressSearch'

interface IRouteToViewProps {
  customer: CustomerModel
  location: ILocatieGlnModel
  existingLocation: DeliveryLocationModel
  warehouse: VestigingEnum
  onRouteToAddressChanged: (
    customer: CustomerModel,
    location: ILocatieGlnModel
  ) => void
  isShipToLocationSet: boolean
}
const RouteToView: FC<IRouteToViewProps> = (
  props: IRouteToViewProps
): ReactElement => {
  const routeToAddressSearchViewRef = useRef<IModalReference>()
  const [customer, setCustomer] = useState<CustomerModel>()
  const [location, setLocation] = useState<ILocatieGlnModel>()
  const [existingLocation, setExistingLocation] =
    useState<DeliveryLocationModel>()

  useEffect(() => {
    setCustomer(props.customer)
    setLocation(props.location)
    setExistingLocation(props.existingLocation)
    console.log('routetoview init')    
  }, [])

  const onAddressChanged = (
    newLocation: ILocatieGlnModel,
    customer: CustomerModel
  ) => {    
    existingLocation.routetocustomergln = customer.customerEanCode.toString()
    existingLocation.routetocustomerid = customer.customerId
    existingLocation.routetolocationgln = newLocation.locatieGlnCode.toString()
    existingLocation.routetolocationname = newLocation.locatieGlnNaam
    existingLocation.routetowarehousename =
      VestigingEnum[newLocation.vestigingCode]

    setExistingLocation(existingLocation)
    setLocation(newLocation)
    setCustomer(customer)
    if (props.onRouteToAddressChanged) {
      props.onRouteToAddressChanged(customer, newLocation)
    }
  }

  const showAddressSearchView = () => {
    routeToAddressSearchViewRef.current.show()
  }

  const clearRouteToData = () => {
    setCustomer(null)
    setLocation(null)    
    props.onRouteToAddressChanged(null, null)
  }

  /**
   * Assuming this component is being used in a table.
   */
  return (
    <>
      <tr className='border'>
        <td>
          <h5>Route-to</h5>
        </td>
        <td>
          {existingLocation?.routetolocationglnid > 0 && (
            <Table borderless={true} size='sm'>
              <tbody>
                <tr>
                  <td className='font-weight-bold text-right'>Klant</td>
                  <td>{customer?.customerNumber}</td>
                  <td className='font-weight-bold text-right'>Klant Gln</td>
                  <td>{customer?.customerEanCode}</td>
                  <td></td>
                </tr>
                <tr>
                  <td className='font-weight-bold text-right'>Klant Naam</td>
                  <td>{customer?.customerName}</td>
                </tr>
                <tr>
                  <td className='font-weight-bold text-right'>Locatie Naam</td>
                  <td>
                    {existingLocation?.routetolocationname ?? 'Geen gegevens'}
                  </td>
                  <td className='font-weight-bold text-right'>Locatie Gln</td>
                  <td>
                    {existingLocation?.routetolocationgln ?? 'Geen gegevens'}
                  </td>
                </tr>
                <tr>
                  <td className='font-weight-bold text-right'>
                    Vestiging{'  '}
                  </td>
                  <td>
                    {existingLocation?.routetowarehousename ?? 'Geen gegevens'}
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </td>
        <td>
          <Button
            disabled={props.isShipToLocationSet}
            variant='primary'
            onClick={showAddressSearchView}
            className='float-right'
          >
            Wijzig
          </Button>
          <Button
            disabled={props.isShipToLocationSet}
            variant='secondary'
            onClick={clearRouteToData}
            className='float-right mr-2'
          >
            X
          </Button>
        </td>
      </tr>

      <RouteToAddressSearch
        ref={routeToAddressSearchViewRef}
        onLinkedAddress={onAddressChanged}
        warehouse={location?.vestigingCode ?? props.warehouse}
        customer={props.customer}
      />
    </>
  )
}

export default RouteToView
